module.exports = __webpack_public_path__ + "img/catagory6.70a3d476.png";